import NewModal from '../components/newModal/newModal'
import DeleteModal from '../components/deleteModal/deleteModal'
import { Button, message, Space, Table, Tag, Tooltip } from 'antd'
import './main.css'
import { useEffect, useState } from 'react'
import { getBannerList } from '../../../api/api'
import { PlusOutlined } from '@ant-design/icons'
import EditorModal from '../components/editorModal/editorModal'
import moment from 'moment'

export default function SwiperManage() {
  const [swiperList, setSwiperList] = useState([])
  const [swiperDetail, setSwiperDetail] = useState({})
  const [total, setTotal] = useState(0)
  const [isFresh, setIsfresh] = useState(false)

  useEffect(() => {
    console.log('refresh!')
    getBannerList().then((res) => {
      const rows = res.data.data.rows
      rows.sort((a,b) => {
        return a.position-b.position
      })
      rows.map((info, index) => {
        info.key = index
        info.updatedAt = moment(info.updated_at).format('YYYY-MM-DD HH:mm:ss')
        return info
      })
      // console.log(res);
      setSwiperList(rows)
      setTotal(res.data.data.total)
      pagination.total = res.data.data.total
    })
  }, [isFresh])

  // useEffect(() => {//初次加载时的数据获取
  //   getBannerList().then((res) => {
  //     res.data.data.rows.map((info, index) => {
  //       return (info.key = index)
  //     })
  //     // console.log(res);
  //     setSwiperList(res.data.data.rows)
  //     setTotal(res.data.data.total)
  //     pagination.total = res.data.data.total
  //   })
  // }, [])
  const columns = [
    {
      title: '轮播图顺序',
      dataIndex: 'position',
      key: 'position',
    },
    {
      title: '轮播图编号',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: '轮播图名称',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: '轮播图URL',
      dataIndex: 'image',
      key: 'image',
      ellipsis: {
        showTitle: false,
      },
      render: (image) => (
        <Tooltip placement="topLeft" title={image}>
          {image}
        </Tooltip>
      ),
    },
    {
      title: '修改时间',
      key: 'updatedAt',
      dataIndex: 'updatedAt',
      ellipsis: {
        showTitle: false,
      },
      render: (updatedAt) => (
        <Tooltip placement="topLeft" title={updatedAt}>
          {updatedAt}
        </Tooltip>
      ),
    },

    {
      title: '操作',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          <EditorModal
            swiperDetail={record}
            total={total}
            setIsFresh={setIsfresh}
          />
          <DeleteModal id={record.id} setIsFresh={setIsfresh} />
        </Space>
      ),
    },
  ]
  const pagination = {
    total: 0,
    showTotal: (total, range) =>
      `共${total}条记录, 第${range[0]}-${range[1]}条`,
    defaultPageSize: 10,
    defaultCurrent: 1,
  }
  const showFullModal = () => {
    message.error('轮播图的数量上限为5个')
  }

  return (
    <div
      className="swiperManage"
      style={{ backgroundColor: 'white', padding: '30px' }}
    >
      <div className="newButton">
        {swiperList.length === 5 ? (
          <Button
            icon={<PlusOutlined />}
            type="primary"
            onClick={showFullModal}
          >
            新建
          </Button>
        ) : (
          <NewModal total={total} setIsFresh={setIsfresh} />
        )}
      </div>

      <Table
        columns={columns}
        dataSource={swiperList}
        pagination={pagination}
        onRow={(record) => {
          return {
            onClick: (event) => {
              setSwiperDetail(record)
            }, // 点击行
            // onDoubleClick: event => {},
            // onContextMenu: event => {},
            // onMouseEnter: event => {}, // 鼠标移入行
            // onMouseLeave: event => {},
          }
        }}
      />
    </div>
  )
}
